<template>
  <v-app class="bg-color">
    <v-main>
      <v-layout row wrap justify-center align-center pt-5>
        <v-flex xs11 lg11>
          <h2>
            <v-icon color="#077893" @click="Fn_BackIndex" size="38"
              >mdi-chevron-left</v-icon
            >{{ $t("template.text2") }}
          </h2>
        </v-flex>
      </v-layout>
      <v-container grid-list-lg fluid class="pb-10 pt-5">
        <v-layout row wrap justify-center align-start>
          <v-flex lg9 xs11 pl-4 pr-4 pt-5 pb-2>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card class="mx-auto pa-9 rounded-lg">
                <v-layout row wrap justify-left align-left>
                  <v-flex lg2 xs12 pl-2>
                    <b>{{ $t("template.text4") }} :</b>
                  </v-flex>
                  <v-flex lg9 xs12>
                    <v-text-field
                      v-model="NameTemplate"
                      :label="$t('template.text4')"
                      :rules="[
                        (v) => !!v || $t('template.text5') + ' Template',
                      ]"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <br />
                <v-layout row wrap justify-left align-left mt-n4>
                  <v-flex lg2 xs12 pl-2>
                    <b>{{ $t("template.text6") }} :</b>
                  </v-flex>
                  <v-flex lg9 xs12>
                    <v-text-field
                      v-model="SubjectEmail"
                      :label="$t('template.text6')"
                      :rules="[
                        (v) => !!v || $t('template.text5') + ' Subject Email',
                      ]"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <br />
                <v-layout row wrap justify-left align-left mt-n4>
                  <v-flex lg12 xs12 pl-2>
                    <b>{{ $t("template.text7") }} :</b>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center align-center>
                  <v-flex lg11 xs12 pl-4 pr-4 pb-2>
                    <v-card-text style="margin-top: -2%">
                      <v-tabs color="#077893" v-model="tab">
                        <v-tab> Editor </v-tab>
                        <v-tab> Html code </v-tab>
                        <!-- tab editor -->
                        <v-tab-item>
                          <vue-editor
                            v-model="Content"
                            :editorToolbar="DefaultToolbar"
                          />
                        </v-tab-item>
                        <!-- tab html code -->
                        <v-tab-item>
                          <v-textarea
                            dark
                            outlined
                            auto-grow
                            no-resize
                            background-color="#077893"
                            row-height="50"
                            v-model="HtmlCode"
                            color="white"
                          ></v-textarea>
                        </v-tab-item>
                      </v-tabs>
                    </v-card-text>
                    <!-- <v-card-text>
                      <v-layout row wrap align-baseline justify-center>
                        <v-flex xs11 sm10 md9 lg10>
                          <div
                            class="mb-3"
                            v-for="(item, i) in textFooter"
                            :key="i"
                          >
                            <v-text-field
                              dense
                              color="#077893"
                              outlined
                              v-model="item.data"
                            ></v-text-field>
                          </div>
                        </v-flex>
                        <v-flex xs11 sm2  md3 lg2 class="text-center">
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            x-small
                            color="#077893"
                            @click="plus()"
                          >
                            <v-icon dark> mdi-plus </v-icon>
                          </v-btn>
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            x-small
                            color="error"
                            :disabled="textFooter.length == 1"
                            @click="minus(textFooter)"
                          >
                            <v-icon dark> mdi-minus </v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text> -->
                    <v-card-actions class="flex-wrap justify-end">
                      <v-spacer></v-spacer>
                      <!-- <v-chip v-if="valSelect === ''" class="ma-2" color="red" text-color="white">
                        <v-icon left> mdi-close </v-icon>
                        {{ $t("template.text21") }}
                      </v-chip>
                      <v-chip v-else class="ma-2" color="success" text-color="white">
                        <v-icon left> mdi-check </v-icon>
                        {{ $t("template.text22") }}
                      </v-chip> -->
                      <v-btn
                        @click="fn_save"
                        color="#077893"
                        class="ma-2 white--text"
                        >{{ $t("policyForm.save") }}</v-btn
                      >
                      <v-btn
                        :disabled="HtmlCode == ''"
                        @click="Fn_Preview"
                        color="#077893"
                        class="ma-2 white--text"
                        >ดูตัวอย่าง</v-btn
                      >
                      <v-btn
                        color="#077893"
                        :disabled="DisabledSave"
                        outlined
                        class="ma-2"
                        @click="fn_openTemplateEmailTest"
                      >
                        {{ $t("template.text15") }}</v-btn
                      >
                      <v-btn
                        to="/email-template-index"
                        outlined
                        color="error"
                        class="ma-2"
                      >
                        <v-icon left> mdi-close-circle-outline </v-icon
                        >{{ $t("smtp.text11") }}
                      </v-btn>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-form>
          </v-flex>
          <v-flex lg3 xs11 pl-4 pr-4 pt-5 pb-2>
            <DialogSelector @fn_selector="Fn_Selector" @test_check="test_check">
            </DialogSelector>
          </v-flex>
        </v-layout>
      </v-container>
      <DialogTemplateEmailTest
        :show="DialogTemplateEmailTest"
        :_SubjectEmail="SubjectEmail"
        :_Content="EncodeHtml"
        :_NameTemplate="NameTemplate"
        @closeDialogTemplateEmailTest="DialogTemplateEmailTest = false"
      />
      <DialogPreview
        :show="DialogPreview"
        :_detail="HtmlCode"
        @closeDialog="DialogPreview = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogPreview from "@/components/dialog/DialogTemplateEmailPreview.vue";
import DialogTemplateEmailTest from "@/components/dialog/DialogTemplateEmailTest";
import DialogSelector from "@/views/Admin/Email/TemplateEmail/TemplteEmailAddRight.vue";

import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { VueEditor } from "vue2-editor";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    VueEditor,
    DialogTemplateEmailTest,
    DialogSelector,
    DialogPreview,
  },
  data: function () {
    return {
      tab: 0,
      valid: true,
      Content: "",
      showTestsendMail: false,
      DialogTemplateEmailTest: false,
      DialogPreview: false,
      HtmlCode: "",
      EncodeHtml: "",
      NameTemplate: "",
      SubjectEmail: "",
      item_select: "",
      rowradio: null,
      SelectSeller: "",
      SelectBuyer: "",
      SelectDocument: "",
      DefaultToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }, { size: 56 }, { background: [] }],
      ],
      HtmlHead: `<html><head>
                        <style>.space {white-space: pre;}   
                        p {margin: 0px;}
                        .ql-align-left {
                          text-align: left;
                        }
                        .ql-align-center {
                          text-align: center;
                        }
                        .ql-align-right {
                          text-align: right;
                        }</style>
                </head><body><div class='space'>`,
      HtmlTail: "</div></body></html>",
      valSelect: "",
      check: "",
      disabled: false,
      DisabledSave: true,
      LoadingCheck: "",
      textFooter: [{ data: "" }],
      data: {},
    };
  },
  computed: {
    CheckTab: {
      get() {
        if (this.tab === 1) {
          return true;
        } else {
          return false;
        }
      },
    },
  },
  methods: {
    plus() {
      this.data = {};
      this.textFooter.push(this.data);
    },
    async minus(i) {
      this.textFooter.splice(i, 1);
    },
    async fn_save() {
      if (this.$refs.form.validate()) {
        this.DisabledSave = false;
        var payload = {
          BusinessId: this.$cookies.get("BusinessId"),
          AccountId: this.$cookies.get("OneAccountId"),
          SubjectEmail: this.SubjectEmail,
          NameTemplate: this.NameTemplate,
          HtmlEmail: this.HtmlCode,
          HtmlEdit: this.Content,
          HtmlCustom: this.CheckTab,
          textFooter: this.textFooter,
        };
        // var Headers = {
        //   AccountId: this.$cookies.get("OneAccountId"),
        // };
        // var dataEncode = await authorization.encodeDataNew(payload);
        // var auth = await authorization.encodeDataNew(Headers);
        // var headers = { Authorization: "Bearer " + auth };
        // this.axios
        //   .post(
        //     process.env.VUE_APP_API_FACTORING_SERVICE +
        //       "config-notify/InsertDetailTemplateEmail",
        //     { Data: dataEncode },
        //     { headers }
        //   )
        //   .then((res) => {
        //     this.DisabledSave = false;
        //     if (res.data.Status === "OK") {
        //       Toast.fire({
        //         icon: "success",
        //         title: this.$i18n.t("alert.temadd"),
        //       });
        //       this.$router.push("/email-template-index");
        //     } else {
        //       Toast.fire({
        //         icon: "error",
        //         title: "' " + res.data.ErrorMessage + " '",
        //       });
        //     }
        //   })
        //   .catch((error) => {
        //     this.DisabledSave = false;
        //     if (error.response) {
        //       Toast.fire({
        //         icon: "error",
        //         title: error.response.data.ErrorMessage,
        //       });
        //     } else if (error.request) {
        //       Toast.fire({
        //         icon: "error",
        //         title: error.request,
        //       });
        //     } else {
        //       Toast.fire({
        //         icon: "error",
        //         title: error.message || error,
        //       });
        //     }
        //   });
      }
    },
    Fn_BackIndex() {
      this.$router.push("/email-template-index");
    },
    fn_openTemplateEmailTest() {
      if (this.tab === 0) {
        this.EncodeHtml = this.HtmlHead + this.Content + this.HtmlTail;
      } else {
        this.EncodeHtml = this.HtmlCode;
      }
      this.DialogTemplateEmailTest = true;
    },
    Fn_Selector(val) {
      if (val.content == "body") {
        if (this.tab == 0) {
          this.Content = this.Content + val.key;
        } else {
          this.HtmlCode = this.HtmlCode + val.key;
        }
      } else {
        this.SubjectEmail = this.SubjectEmail + val.key;
      }
    },
    test_check(val) {
      if (val.content == "body") {
        if (this.tab == 0) {
          this.Content = this.Content + val.key;
        } else {
          this.HtmlCode = this.HtmlCode + val.key;
        }
      } else {
        this.SubjectEmail = this.SubjectEmail + val.key;
      }
      this.valSelect = val.test;
      if (this.valSelect === "") {
        this.DisabledSave = true;
      } else {
        this.DisabledSave = false;
      }
    },
    Fn_Preview() {
      this.DialogPreview = true;
    },
  },
  mounted() {
    if (this.valSelect === "") {
      this.DisabledSave = true;
    } else {
      this.DisabledSave = false;
    }
  },
  watch: {
    Content(val) {
      if (this.Content.includes("{{ButtonCheck}}") === true) {
        this.DisabledSave = false;
      } else {
        this.valSelect = "";
        this.DisabledSave = true;
      }
    },
  },
};
</script>

<style scoped>
.special-text {
  /* background-color: rgb(9, 53, 73); */
  border: 2px solid rgb(9, 53, 73);
  width: 250px;
  height: 100px;
  display: flex;
  color: black;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.bg-color {
  background-color: #ddf7ff;
}
</style>

<style>
body {
  overflow: hidden !important;
}
</style>
